import {
  PHOBIA_LIST_ALPABETICAL,
  DISORDER_LIST,
  PHOBIA_ACTION_MAP,
} from "@/config";
import { generate } from "shortid";
import { PAGE_THEMES, PAGE_TYPES } from "../../types";
import { getCategoryById } from "@/utils";
import { TARGET_DATA } from "../../../forms";

export const PREMIUM_WELCOME_PAGES = {
  get_started_page: {
    id: `get_started_page-${generate()}`,
    type: "get_started_type",
    custom_back: null,
    backwards_navigation_enabled: true,
    title: null,
    module_name: "premium_welcome",
    target_state: "welcome_data",
    target_field: "get_started",
    target_pages: [],
    component_type: null,
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "Adam Hutchinson",
      description: "oVRcome Founder",
      image: "nice-pic-of-adam",
      default_progression: "choose_phobia_page",
      options: [
        {
          id: `option-item-${generate()}`,
          label: "Welcome to oVRcome",
          description: "Hi, I'm Adam. I suffered from Social Anxiety.", //"We can't wait to get you started!",
          icon: null,
          target_field: null,
          to: null,
          value: null,
          content:
            "I felt ashamed and it affected my self-esteem. With Exposure Therapy, I was able to overcome it. \n\nNow through oVRcome, this amazing treatment is available to everyone.", //"Living a day in fear is a day wasted. Let's get you the life you want.",
          isActive: false,
        },
      ],
    },
  },
  choose_problem_page: {
    id: `choose_problem_page-${generate()}`,
    type: "single_select_type",
    title: null,
    module_name: "premium_welcome",
    backwards_navigation_enabled: true,
    target_state: "welcome_data",
    target_field: "choose_problem",
    target_component: null,
    component_type: null,
    target_pages: [
      {
        name: "anxiety_profile_comfortability_page",
        data_key: "options",
        action: (data) => {
          switch (data) {
            case 4:
              return PHOBIA_ACTION_MAP.social_anxiety.comfortable_lables.map(
                (label, index) => ({
                  value: label,
                  id: index,
                  label: label,
                  isActive: false,
                })
              );
            default:
              return [];
          }
        },
      },
      {
        name: "anxiety_profile_fears_page",
        data_key: "options",
        action: (data) => {
          switch (data) {
            case 4:
              return PHOBIA_ACTION_MAP.social_anxiety.fear_of_labels.map(
                (label, index) => ({
                  value: label,
                  id: index,
                  label: label,
                  isActive: false,
                })
              );
            default:
              return [];
          }
        },
      },
      {
        name: "anxiety_profile_fears_page",
        data_key: "title",
        action: (data) => {
          let title = "What is it about {{phobia}} that actually scares you?";

          switch (data) {
            case 4:
              return title.replace("{{phobia}}", "social situations");
            default:
              return title.replace("{{phobia}}", "your phobia");
          }
        },
      },
      {
        name: "phobia_info_page",
        data_key: "default_progression",
        action: (data) => {
          switch (data) {
            case 4:
              return "anxiety_profile_goals_info_page";
            default:
              return "celebrate_page";
          }
        },
      },
      {
        name: "phobia_info_page",
        data_key: "title",
        action: (data) => {
          const disorder = DISORDER_LIST.find((opt) => opt.value === data);

          if (disorder) {
            return getCategoryById(disorder.value).statement.title;
          }

          return null;
        },
      },
      {
        name: "phobia_info_page",
        data_key: "description",
        action: (data) => {
          const disorder = DISORDER_LIST.find((opt) => opt.value === data);

          if (disorder) {
            return getCategoryById(disorder.value).statement.description;
          }

          return null;
        },
      },
      {
        name: "treatment_select_page",
        data_key: "title",
        action: (data) => {
          const disorder = DISORDER_LIST.find((opt) => opt.value === data);

          if (disorder) {
            return `Have you tried treating your ${getCategoryById(
              data
            ).title.toLocaleLowerCase()}?`;
          }

          return null;
        },
      },
    ],
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "What would you like to overcome?", //"What do you need help with?",
      description: "Choose one you would like to work on:", //"Choose one that affects you most day to day",
      image: null,
      custom_back: null,
      default_progression: null,
      options: [
        {
          id: `option-item-2-${generate()}`,
          label: "A phobia",
          to: "choose_phobia_page",
          text: "See all →",
          value: "phobia",
          target_field: "choose_problem",
          icon: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-0-${generate()}`,
          label: "Social Anxiety",
          to: "phobia_info_page",
          icon: "social-anxiety",
          value: 4,
          target_field: "choose_phobias",
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-1-${generate()}`,
          label: "Panic Disorder with Agoraphobia",
          to: "phobia_info_page",
          icon: "programs/panic-disorder-black",
          value: 14,
          target_field: "choose_phobias",
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-2-${generate()}`,
          label: "Mild Depression",
          to: "phobia_info_page",
          icon: "programs/mild-depression",
          value: 1001,
          target_field: "choose_phobias",
          text: null,
          description: null,
          isActive: false,
        },
      ],
    },
  },
  choose_phobia_page: {
    id: `choose_phobia_page-${generate()}`,
    type: "single_select_type",
    backwards_navigation_enabled: true,
    title: null,
    module_name: "premium_welcome",
    target_state: "welcome_data",
    target_field: "choose_phobias",
    target_pages: [
      {
        name: "anxiety_profile_comfortability_page",
        data_key: "options",
        action: (data) => {
          switch (data) {
            case 6:
              return PHOBIA_ACTION_MAP.acrophobia.comfortable_lables.map(
                (label, index) => ({
                  value: label,
                  id: index,
                  label: label,
                  isActive: false,
                })
              );
            case 7:
              return PHOBIA_ACTION_MAP.aerophobia.comfortable_lables.map(
                (label, index) => ({
                  value: label,
                  id: index,
                  label: label,
                  isActive: false,
                })
              );
            default:
              return [];
          }
        },
      },
      {
        name: "anxiety_profile_fears_page",
        data_key: "options",
        action: (data) => {
          switch (data) {
            case 6:
              return PHOBIA_ACTION_MAP.acrophobia.fear_of_labels.map(
                (label, index) => ({
                  value: label,
                  id: index,
                  label: label,
                  isActive: false,
                })
              );
            case 7:
              return PHOBIA_ACTION_MAP.aerophobia.fear_of_labels.map(
                (label, index) => ({
                  value: label,
                  id: index,
                  label: label,
                  isActive: false,
                })
              );
            default:
              return [];
          }
        },
      },
      {
        name: "phobia_info_page",
        data_key: "default_progression",
        action: (data) => {
          switch (data) {
            case 6:
            case 7:
              return "anxiety_profile_goals_info_page";
            default:
              return "celebrate_page";
          }
        },
      },
      {
        name: "anxiety_profile_fears_page",
        data_key: "title",
        action: (data) => {
          let title = "What is it about {{phobia}} that actually scares you?";

          switch (data) {
            case 6:
              return title.replace("{{phobia}}", "heights");
            case 7:
              return title.replace("{{phobia}}", "flying");
            default:
              return title.replace("{{phobia}}", "your phobia");
          }
        },
      },
      {
        name: "phobia_info_page",
        data_key: "title",
        action: (data) => {
          return getCategoryById(data).statement.title;
        },
      },
      {
        name: "phobia_info_page",
        data_key: "description",
        action: (data) => {
          return getCategoryById(data).statement.description;
        },
      },
      {
        name: "treatment_select_page",
        data_key: "title",
        action: (data) => {
          return `Have you tried treating your ${getCategoryById(data).title}?`;
        },
      },
    ],
    component_type: null,
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "What phobia do you need help with?",
      description: "Choose one that affects you most day to day",
      no_phobia_text: "Don't see your phobia?",
      image: null,
      custom_back: null,
      default_progression: "choose_problem_page",
      options: PHOBIA_LIST_ALPABETICAL.map((phobia, i) => ({
        id: `option-item-${i}-${generate()}`,
        label: phobia.description,
        description: phobia.title,
        icon: phobia.image,
        target_field: "choose_phobias",
        to: "phobia_info_page",
        value: phobia.id,
        content: phobia.text,
        isActive: false,
      })).concat({
        id: `option-item-phobia-${generate()}`,
        label: "Don't see your phobia?",
        to: "let_us_know_page",
        description: "Let us know",
        icon: "programs/no-phobia",
        target_field: "choose_phobias",
        content: "let us know yeah",
        isActive: false,
      }),
    },
  },
  let_us_know_page: {
    id: `let_us_know_page-${generate()}`,
    type: "let_us_know_type",
    custom_back: null,
    backwards_navigation_enabled: true,
    title: null,
    module_name: "premium_welcome",
    target_state: "welcome_data",
    target_field: "get_started",
    target_pages: [],
    component_type: null,
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "Let us know",
      description: "What would you like to overcome?",
      default_progression: "choose_phobia_page",
      options: [
        {
          id: `option-item-${generate()}`,
          label: "Let us know",
          description: "What would you like to overcome?",
          icon: null,
          target_field: null,
          to: "choose_phobia_page",
          value: null,
          content:
            "We are always working on new programs. We'll notify you as soon as the program you're after is available.",
          isActive: false,
        },
      ],
    },
  },
  phobia_info_page: {
    id: `phobia_info_page-${generate()}`,
    type: "info_type",
    backwards_navigation_enabled: true,
    title: null,
    module_name: "premium_welcome",
    target_state: null,
    target_field: null,
    theme: PAGE_THEMES.WARM,
    target_pages: [],
    data: {
      title: "Did you know that 9.1% of people suffer from phobias?",
      description:
        "Everybody is scared of something. But when that fear starts to get in the way of your daily life - it’s time to get rid of your phobia for good!",
      image: "illustrations/anxious",
      custom_back: null,
      default_progression: "name_input_page",
      options: [],
    },
  },
  celebrate_page: {
    id: `celebrate_page-${generate()}`,
    type: PAGE_TYPES.details,
    backwards_navigation_enabled: true,
    title: null,
    module_name: "premium_program",
    target_state: TARGET_DATA.program,
    target_field: null,
    target_pages: [],
    component_type: null,
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "Clinically proven to work", //"You’re in good hands",
      description: "86.5%",
      image: null,
      custom_back: null,
      default_progression: "treatment_select_page",
      options: [
        {
          id: `extra-content-1-${generate()}`,
          label: "of people using oVRcome experienced a reduction in anxiety.",
          value: null,
          target_field: null,
          to: null,
          icon: "orgs/uoo",
          text: "*Lacey, C., Frampton, C., & Beaglehole, B. (2022). oVRcome – Self-guided virtual reality for specific phobias: A randomised controlled trial. Australian & New Zealand Journal of Psychiatry, 000486742211107. https:// doi.org/10.1177/00048674221110779",
          description: "Proven in a controlled clinical trial",
          isActive: false,
        },
      ],
    },
  },
  name_input_page: {
    id: `name_input_page-${generate()}`,
    type: "input_type",
    backwards_navigation_enabled: true,
    title: "Your profile",
    module_name: "premium_welcome",
    target_state: "welcome_data",
    target_field: "name_input",
    target_pages: [],
    component_type: null,
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "What's your name?",
      description: null,
      image: null,
      custom_back: null,
      default_progression: "age_select_page",
      options: [],
    },
  },
  age_select_page: {
    id: `age_select_page-${generate()}`,
    type: "single_select_type",
    backwards_navigation_enabled: true,
    title: "Your profile",
    module_name: "premium_welcome",
    target_state: "welcome_data",
    target_field: "age_select",
    target_pages: [],
    component_type: "centered",
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "How old are you?",
      description: "We’ll tailor your program to your age group",
      image: null,
      default_progression: "gender_select_page",
      custom_back: null,
      options: [
        {
          id: `option-item-0-${generate()}`,
          label: "18 - 25",
          to: "gender_select_page",
          value: "18-25",
          target_field: "age_select",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-1-${generate()}`,
          label: "26 - 35",
          to: "gender_select_page",
          value: "26-35",
          target_field: "age_select",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-2-${generate()}`,
          label: "36 - 45",
          to: "gender_select_page",
          value: "36-45",
          target_field: "age_select",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-3-${generate()}`,
          label: "45 - 55",
          to: "gender_select_page",
          value: "45-55",
          target_field: "age_select",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-4-${generate()}`,
          label: "56+",
          value: "56+",
          to: "gender_select_page",
          target_field: "age_select",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
      ],
    },
  },
  gender_select_page: {
    id: `gender_select_page-${generate()}`,
    type: "single_select_type",
    backwards_navigation_enabled: true,
    title: "Your profile",
    module_name: "premium_welcome",
    target_state: "welcome_data",
    target_field: "choose_gender",
    target_pages: [],
    component_type: "centered",
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "What's your gender?",
      description:
        "This helps us personalize your plan. Gender affects anxiety. We also experience anxiety differently across genders.",
      image: null,
      custom_back: null,
      default_progression: null,
      options: [
        {
          id: `option-item-0-${generate()}`,
          label: "Male",
          to: "program_little_bit_often", //"program_category_page",
          value: "male",
          target_field: "choose_gender",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-1-${generate()}`,
          label: "Female",
          to: "program_little_bit_often", //"program_category_page",
          value: "female",
          target_field: "choose_gender",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-2-${generate()}`,
          label: "Gender diverse",
          to: "program_little_bit_often", //"program_category_page",
          value: "diverse",
          target_field: "choose_gender",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-3-${generate()}`,
          label: "Prefer not to say",
          to: "program_little_bit_often", //"program_category_page",
          value: "unknown",
          target_field: "choose_gender",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
      ],
    },
  },
  treatment_select_page: {
    id: `treatment_select_page-${generate()}`,
    type: "multi_select_type",
    backwards_navigation_enabled: true,
    title: "Your profile",
    module_name: "premium_welcome",
    target_state: "welcome_data",
    target_field: "choose_treatments",
    target_pages: [],
    component_type: null,
    theme: PAGE_THEMES.LIGHT,
    data: {
      title: "Have you tried treating your Phobia?",
      description: "Choose all that apply",
      image: null,
      custom_back: null,
      default_progression: "therapist_developed_program", //"age_select_page",
      options: [
        {
          id: `option-item-0-${generate()}`,
          label: "I've not tried anything",
          value: "not_tried_anything",
          target_field: "choose_treatments",
          to: null,
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-1-${generate()}`,
          label: "I've tried therapy",
          value: "tried_therapy",
          target_field: "choose_treatments",
          to: null,
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-2-${generate()}`,
          label: "I'm currrently seeing a therapist",
          value: "seeing_therapist",
          target_field: "choose_treatments",
          to: null,
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-3-${generate()}`,
          label: "I Google for information",
          to: "gender_select_page",
          value: "googled_information",
          target_field: "choose_treatments",
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-4-${generate()}`,
          label: "I've used another app",
          value: "used_another_app",
          target_field: "choose_treatments",
          to: null,
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-5-${generate()}`,
          label: "I've used medication",
          value: "used_medication",
          target_field: "choose_treatments",
          to: null,
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
        {
          id: `option-item-6-${generate()}`,
          label: "Something else",
          value: "something_else",
          target_field: "choose_treatments",
          to: null,
          icon: null,
          text: null,
          description: null,
          isActive: false,
        },
      ],
    },
  },
  therapist_developed_program: {
    id: `therapist_developed_program-${generate()}`,
    type: PAGE_TYPES.info,
    backwards_navigation_enabled: true,
    title: null,
    module_name: "premium_program",
    target_state: TARGET_DATA.program,
    target_field: null,
    target_pages: [],
    component_type: null,
    theme: PAGE_THEMES.WARM,
    data: {
      title: "Our program is developed by Clinical Psychologists",
      description: "Learn a unique set of skills/techniques to manage anxiety.",
      image: "therapists",
      continue_button_label: "Continue",
      custom_back: "treatment_select_page",
      default_progression: "age_select_page",
      options: [],
    },
  },
};
